import React from 'react';

import { useIntlDictionary } from 'hooks/useIntlDictionary';
import { PressControlComponent } from 'design/pressControl';
import { TextComponent } from 'design/text/textComponents';
import { ThemeProviderComponent } from 'design/themeProvider';
import { CenteredLayoutComponent } from 'design/centeredLayout/centeredLayoutComponents';
import { FinishScreenLayout } from 'design/finishScreenLayout/finishScreenLayout';
import { useMobileAppReferer } from 'hooks/useProdStackManagerReferer';
import { MobileAppReferer } from 'utils/MobileAppReferer';
import { useAppState } from 'hooks/useAppState';
import { formatE164PhoneNumber } from 'utils/phoneNumberUtils';
import { ProdStackInfo } from 'types/state';

type Props = {
  prodStackInfo: ProdStackInfo;
};

export const ProdStackManagerFinishComplete = (props: Props) => {
  const {
    prodStackInfo: { loginHash, loginURL, firstLogin },
  } = props;

  const { personalInfoFormValues } = useAppState();

  const phoneLabel = React.useMemo(() => {
    const phone = formatE164PhoneNumber(personalInfoFormValues.phone);
    return phone || firstLogin || '';
  }, [firstLogin, personalInfoFormValues.phone]);

  const mobileAppReferer = useMobileAppReferer();

  const {
    prodStackManager: { finishComplete: ownDictionary },
  } = useIntlDictionary();

  const goToProdStack = React.useCallback(() => {
    if (loginURL) {
      window.open(loginURL, '_self');
    }
  }, [loginURL]);

  const goToMobileApp = React.useCallback(() => {
    if (loginHash && firstLogin && loginURL) {
      const url = MobileAppReferer.createSignupCompleteURL(
        loginHash,
        firstLogin,
        loginURL
      );

      window.open(url, '_self');
    }
  }, [firstLogin, loginHash, loginURL]);

  return (
    <ThemeProviderComponent mode="prodRegistraionComplete">
      <CenteredLayoutComponent>
        <FinishScreenLayout
          topAlign="end"
          top={
            <TextComponent breakAll weight="medium" size="mppp">
              {phoneLabel}
            </TextComponent>
          }
          middle={
            <TextComponent>
              {ownDictionary.savePhoneInstructionText}
            </TextComponent>
          }
          bottom={
            <PressControlComponent
              theme="accent"
              type="button"
              onPress={mobileAppReferer ? goToMobileApp : goToProdStack}
            >
              {ownDictionary.actionText}
            </PressControlComponent>
          }
        />
      </CenteredLayoutComponent>
    </ThemeProviderComponent>
  );
};
